const en = {
  "Generation_Form_{label}MoetGroterZijnDan{amount}": "'{{label}}' should be larger than {{amount}}.",
  "Generation_Form_{label}MoetMinimaal{amount}Zijn": "'{{label}}' should be at least {{amount}}.",
  "Generation_Form_{label}MoetKleinerZijnDan{amount}": "'{{label}}' should be smaller than {{amount}}.",
  "Generation_Form_{label}MagMaximaal{amount}Zijn": "'{{label}}' should be at most {{amount}}.",
  "Generation_Form_MinimaalEen{label}IsVerplicht": "At least one '{{label}}' is required.",
  "Generation_Form_{label}MoetEenBedragZijn": "'{{label}}' should be an amount.",
  "Generation_Form_{label}MoetEenBsnZijn":
    "The field '{{label}}' was not filled in correctly. The citizen service number consists of 9 digits.",
  "Generation_Form_{label}MoetEenKvknummerZijn":
    "The field '{{label}}' was not filled in correctly. The KVK number consists of 8 digits.",
  "Generation_Form_{label}MoetGelijkZijnAan{compareValue}":
    "'{{label}}' is unequal to '{{compareValue}}' and therefore not allowed.`",
  "Generation_Form_{label}MoetOngelijkZijnAan{compareValue}":
    "'{{label}}' is equal to '{{this.compareValue}}' and therefore not allowed.",
  "Generation_Form_{label}MoetEenDatumZijn": "You have filled the field '{{label}}' with an invalid date.",
  "Generation_Form_{label}MoetEenDecimaalZijn": "'{{label}}' is invalid.",
  "Generation_Form_{label}MoetEenGeldigEmailAdresZijn":
    "The field '{{label}}' was not filled in correctly, for example: name@domain.nl (replace with your own email address).",
  "Generation_Form_{label}MoetGelijkZijnAan{valueToEqual}": "'{{label}}' is not equal to '{{valueToEqual}}'.",
  "Generation_Form_Alleen{extensions}ZijnGeldig": "Only the extensions '{{extensions}}' are allowed.",
  "Generation_Form_{fileLabel}MoetVanHetType{extensions}Zijn":
    "'{{fileLabel}}' has an invalid extension. Only the extensions '{{extensions}}' are allowed.",
  "Generation_Form_{label}MagNietGroterZijnDan{maxSizeInMB}":
    "You have uploaded more than the maximum allowed file size in the field '{{label}}', attachments may be a maximum of {{maxSizeInMB}}MB.",
  "Generation_Form_{fileLabel}MagNietGroterZijnDan{maxSizeInMB}":
    "'{{fileLabel}}' is too large. Add an attachment of up to {{maxSizeInMB}} MB.",
  "Generation_Form_{label}MagMaximaal{maxFiles}BijlagenZijn":
    "You have uploaded more than the allowed number of attachments in the field '{{label}}', you may upload a maximum of {{maxFiles}} attachment(s).",
  "Generation_Form_{label}MoetMinimaal{minFiles}BijlagenZijn":
    "You have uploaded less than the required number of attachments in the field '{{label}}', you must upload a minimum of {{minFiles}} attachment(s).",
  "Generation_Form_{label}MagNietGroterZijnDan{maxLength}":
    "'{{label}}' may not have more than {{maxLength}} characters.",
  "Generation_Form_{label}MoetMinimaal{mizSizeInBytes}Zijn":
    "You have uploaded less than the minimum allowed file size in the field '{{label}}', attachments must be at least {{minSizeInBytes}} byte(s) in size.",
  "Generation_Form_{fileLabel}MoetMinimaal{mizSizeInBytes}Zijn":
    "'{{fileLabel}}' is smaller than the minimum allowed file size, attachments must be at least {{minSizeInBytes}} byte(s) in size.",
  "Generation_Form_{label}GetalMoetMinimaal{amount}Zijn":
    "'{{label}}' number must be at least {{amount}} or higher.",
  "Generation_Form_{label}MoetBestaanUit{specificLength}Characters":
    "'{{label}}' must consist of {{specificLength}} characters.",
  "Generation_Form_{label}MoetEenGeldigIBANZijn":
    "The field '{{label}}' was not filled in correctly, for example: NL01ABCD0123456789 (replace with your own IBAN).",
  "Generation_Form_{label}MoetEenGeheelGetalZijn": "'{{label}}' is invalid.",
  "Generation_Form_{label}MagGeenLegeFileBevatten":
    "You have uploaded an empty attachment in the field '{{label}}', attachments may not be empty.",
  "Generation_Form_{fileLabel}MagGeenLegeFileZijn":
    "'{{fileLabel}}' is an empty attachment, attachments may not be empty.",
  "Generation_Form_{label}IsVerplicht": "The field '{{label}}' was not filled in.",
  "Generation_Form_{label}IsNotEqualTo{firstLabel}": "'{{label}}' is not equal to '{{firstLabel}}'.",
  "Generation_Form_{label}MoetOpOfNa{minimumDate}Zijn": "'{{label}}' must be on or after {{minimumDate}}.",
  "Generation_Form_{label}MoetOpOfVoor{maximumDate}Zijn":
    "'{{label}}' must be on or before {{maximumDate}} zijn.",
  "Generation_Form_{label}IsEqualTo{firstLabel}": "'{{label}}' is equal to '{{firstLabel}}'.",
  "Generation_Form_{label}IsGeenGeldigeDatumOfInDeToekomst":
    "You have filled the field '{{label}}' with a future date.",
  "Generation_Form_{label}IsGeenGeldigTelefoonnummer":
    "The field '{{label}}' was not filled in correctly, for example: 040-1234567 (replace with your own telephone number).",
  "Generation_Form_{label}IsGeenGeldigePostcode":
    "The field '{{label}}' was not filled in correctly, for example: 1234 AB (replace with your own postal code).",
  "Generation_Form_{label}IsGeenGeldigeWaard": "The field '{{label}}' was not filled in correctly.",
  "Generation_Form_{label}MoetKleinerOfGelijkZijnAan{datumTmLabel}":
    "{{label}} may not be after {{datumTmLabel}}.",
  "Generation_Form_{label}MoetKleinerZijnDan{datumTmLabel}": "{{label}} must be before {{datumTmLabel}}.",
  "Generation_Form_{label}IsGeenGeldigeWaarde":
    "You have not entered a valid value in the field '{{label}}'.",
  Tooltip_MeerInformatie: "More information"
};

export default en;
